export default {
    props: ["data"]
};


// WEBPACK FOOTER //
// ./src/components/base/view/cmps/breadcrumb/src/breadcrumb.js